import { setGenerateCount, setNegativePrompt, setTxt2ImgTexts, statusStore } from "@/stores/status";
import { Editor_Words } from "@/utils/lang/editor";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import { ReactNode, useMemo } from "react";
import { SubWithTitle } from "@/components/SubPanel/WithTitle";
import { Box, Center, chakra, Flex } from "@chakra-ui/react";
import TextArea from "@/components/TextArea";
import { InfoText, LabelText } from "../../styleComponents/Texts";
import { ImageWithPlaceHolder } from "@/components/Image/WithPlaceHolder";
import { MODEL_TYPES_INFO } from "@/modules/editor/constant";
import { useInpaintingImage } from "./hooks/useInpaintingImage";
import { useInpaintingMask } from "./hooks/useInpaintingMask";
import { GenMultiInput } from "../GenMultiInput";
import { isAuthUser } from "@/utils/status";

const w = "100%";
const margin = "24px";
const textAreaH = 120;
type RenderConfigType = {
  textArea?: {
    placeholder?: string;
    titleWord?: Editor_Words;
  };
  generateCountInput?: {
    min?: number;
    max?: number;
  };
};
export const InpaintingPanel = observer<{
  titleWord: Editor_Words;
  labelWord: Editor_Words;
  maskTitleWord: Editor_Words;
  submitPanel: ReactNode;
  extraRenderConfig?: RenderConfigType;
}>(({ titleWord, labelWord, submitPanel, maskTitleWord, extraRenderConfig }) => {
  const lang = langStore.tgt;
  const { inpaintingImageAlias, inpaintingImageSrc, inpaintingMaskSrc } = statusStore;

  const { modelType, sizeString, imagePlaceHolder } = useInpaintingImage();
  const { maskPlaceHolder } = useInpaintingMask();

  const imageSelected = useMemo(() => !!inpaintingImageAlias, [inpaintingImageAlias]);
  console.log("inpaintingMaskAlias: ", statusStore.inpaintingMaskAlias);
  return (
    <SubWithTitle mb={margin} title={translate(titleWord, lang)} pos="relative">
      {/* 底图 */}
      <Center mt="16px" flexDirection="column">
        <LabelText w="100%">{translate(Editor_Words[labelWord], lang)}：</LabelText>
        <ImageWithPlaceHolder url={inpaintingImageSrc} placeholderText={imagePlaceHolder} />
      </Center>
      {/* 待消除区域 */}
      <Center flexDirection="column">
        <LabelText w="100%">{translate(Editor_Words[maskTitleWord], lang)}：</LabelText>
        <ImageWithPlaceHolder url={inpaintingMaskSrc} placeholderText={maskPlaceHolder} />
      </Center>

      {extraRenderConfig?.textArea ? (
        <>
          {extraRenderConfig.textArea.titleWord ? (
            <LabelText mt="5px">
              {translate(Editor_Words[extraRenderConfig.textArea.titleWord], lang)}：
            </LabelText>
          ) : null}
          <TextArea
            w={w}
            mb="16px"
            lang={lang}
            textAreaH={textAreaH}
            placeholderWord={
              extraRenderConfig.textArea.placeholder ?? Editor_Words["textarea-placeholder"]
            }
            text={statusStore.txt2imgTexts}
            setText={setTxt2ImgTexts}
          />
          <LabelText>{translate(Editor_Words["negaprompt-input"], lang)}：</LabelText>
          <TextArea
            w="100%"
            mb="16px"
            lang={lang}
            textAreaH={120}
            placeholderWord={Editor_Words["negative-prompt-placeholder"]}
            text={statusStore.negativePrompt}
            setText={setNegativePrompt}
          />
        </>
      ) : (
        <Box mb="16px"></Box>
      )}

      {imageSelected ? (
        <InfoText fontSize="14px" mt="16px">
          <chakra.span color="#fff">{translate(Editor_Words["size"], lang)}：</chakra.span>
          {translate(Editor_Words["stay-in-step-with-selected-pic"], lang)}
        </InfoText>
      ) : null}
      {imageSelected ? (
        <Flex flexDirection="column" gap="12px" mt="16px">
          {modelType ? (
            <InfoText>
              {translate(Editor_Words["model"], lang)}：
              {translate(MODEL_TYPES_INFO[modelType]?.showInfo, lang)}
            </InfoText>
          ) : null}
          <InfoText>
            {translate(Editor_Words["resolution"], lang)}： {sizeString}
          </InfoText>
        </Flex>
      ) : null}
      {extraRenderConfig?.generateCountInput && isAuthUser() && (
        <GenMultiInput
          mt="16px"
          value={statusStore.generateCount}
          onChange={setGenerateCount}
          min={extraRenderConfig.generateCountInput.min ?? 1}
          max={extraRenderConfig.generateCountInput.max ?? 100}
        />
      )}

      {submitPanel}
    </SubWithTitle>
  );
});
